import { createSelector } from 'reselect';

import { getUsers, getAllUsers } from 'selectors/entities/userSelectors';
import { getUserShortName } from 'helpers/userHelper';
import { dateFormat } from 'util/config';
import moment from 'moment';

export const getEventSchedules = (state) =>
  state.getIn(['entities', 'schedule']).filter((schedule) => schedule.get('entity') === 'event');

export const getEventScheduleById = (state, { scheduleId }) =>
  state.getIn(['entities', 'schedule', parseInt(scheduleId)]);

// Returns all events from state
export const getEvents = (state, props = {}) =>
  state.getIn(['entities', 'event', 'events']).filter((event) => {
    if (props.eventSearch) {
      const value = event.get('name') + event.get('startDate') + event.get('endDate') + event.get('description');
      return value?.toLowerCase()?.indexOf(props.eventSearch.toLowerCase()) !== -1;
    } else {
      return true;
    }
  });

export const getDrawerEvents = (state) => {
  const second = moment().add(30, 'days');
  return state.getIn(['entities', 'event', 'events']).filter((event) => {
    const first = moment(event.get('startDate'), dateFormat);
    return (first.isSame(moment(), 'day') || first.isAfter(moment())) && second.isAfter(first);
  });
};

// Returns event by id
export const getEventById = (state, props = {}) =>
  state.getIn(['entities', 'event', 'events', parseInt(props.eventId)]);

export const getEventTypesFromState = (state) => state.getIn(['entities', 'event', 'eventTypes']);

// Returns all event types from state
export const getEventTypes = (state, props = {}) =>
  getEventTypesFromState(state).filter((type) => {
    if (props.eventTypeSearch) {
      const value = type.get('name') + type.get('description');
      return value?.toLowerCase()?.indexOf(props.eventSearch.toString()) !== -1;
    } else {
      return true;
    }
  });

// Returns event type by id
export const getEventTypeById = (state, props = {}) => state.getIn(['entities', 'event', 'eventTypes', props.typeId]);
// Returns all events with summary
export const getEventsWithSummary = createSelector(
  [getEvents, getEventTypes, getUsers, getEventSchedules],
  (events, types, users, schedules) => {
    if (events) {
      return events.map((event) => {
        if (schedules && event.get('scheduleId')) {
          event = event.set('schedule', schedules.get(event.get('scheduleId')));
        }
        if (types) {
          event = event.set('type', types.get(event.get('typeId')));
        }
        if (users) {
          event = event.set('user', users.get(event.get('userId')));
        }
        if (!event.get('name')) {
          if (event.get('type')) {
            event = event.set('name', event.getIn(['type', 'name']));
          }
          if (event.get('user')) {
            event = event.set('name', `${event.get('name')} — ${getUserShortName(event.get('user'))}`);
          }
        }
        return event;
      });
    }
    return null;
  },
);

// Return event by id with summary
export const getEventByIdWithSummary = createSelector(
  [getEventById, getEventTypes, getAllUsers, getEventSchedules],
  (event, types, users, schedules) => {
    if (event) {
      if (schedules && event.get('scheduleId')) {
        event = event.set('schedule', schedules.get(event.get('scheduleId')));
      }
      if (types) {
        event = event.set('type', types.get(event.get('typeId')));
      }
      if (users) {
        event = event.set('user', users.get(event.get('userId')));
      }
      return event;
    }
    return null;
  },
);
